// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniCartToggle_container__GlHAI","icon":"MiniCartToggle_icon__ad5WD","badge":"MiniCartToggle_badge__HK7Da"};